import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cancel-changes-banner',
  templateUrl: './cancel-changes-banner.component.html',
  styleUrls: ['./cancel-changes-banner.component.scss']
})
export class CancelChangesBannerComponent {
  @Input() text = '';
  @Output() cancel = new EventEmitter<void>();

  get formattedText(): string {
    if (!this.text) {
      return '';
    }

    return this.text
      .replace(/\r\n|\r|\n|\/n/g, '<br>')
      .replace(/\s?<br>$/g, '');
  }

  handleCancel(): void {
    this.cancel.emit();
  }
}

